import { IRolesResponse } from "../../data/interfaces/user/IRoles";
import { IUserResponse } from "../../data/interfaces/user/IUserResponse";
import { IUserState } from "./interfaces/IUserState";
import { UserActionKeys, UserActionUnion } from "./User.actions";

const initialState: IUserState = {
  users: [] as IUserResponse[],
  roles: [] as IRolesResponse[],
  isLoading: false,
  error: undefined,
  message: undefined,
}

const userReducer = (state = initialState, action: UserActionUnion): IUserState => {

  var users: IUserResponse[];

  switch (action.type) {
    case UserActionKeys.LIST_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UserActionKeys.LIST_USERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        users: action.payload,
      };
    case UserActionKeys.LIST_USERS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case UserActionKeys.LIST_ROLES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UserActionKeys.LIST_ROLES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        roles: action.payload
      };
    case UserActionKeys.LIST_ROLES_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case UserActionKeys.USER_REGISTER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UserActionKeys.USER_REGISTER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        users: [...state.users, action.payload],
      };
    case UserActionKeys.USER_REGISTER_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case UserActionKeys.USER_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UserActionKeys.USER_UPDATE_SUCCESS:
      users = [...state.users];
      var oldUserIndex = users.findIndex(x => x.id == action.payload.id);
      users[oldUserIndex] = action.payload;

      return {
        ...state,
        isLoading: false,
        users: users,
      };
    case UserActionKeys.USER_UPDATE_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case UserActionKeys.USER_DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UserActionKeys.USER_DELETE_SUCCESS:
      users = [...state.users].filter(x => x.id != action.payload);

      return {
        ...state,
        isLoading: false,
        users: users,
      };
    case UserActionKeys.USER_DELETE_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case UserActionKeys.USER_UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UserActionKeys.USER_UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case UserActionKeys.USER_UPDATE_PASSWORD_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
